import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b203e36"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/opter/repo/code/cloudsee-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b203e36')) {
      api.createRecord('4b203e36', component.options)
    } else {
      api.reload('4b203e36', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b203e36", function () {
      api.rerender('4b203e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ChangePasswordDialog/index.vue"
export default component.exports